<div class="truckJourneyInfo">
    <div class="truckJourneyInfo-header">
        <div class="truckJourneyInfo-header-block">
            <div class="truckJourneyInfo-header-line">
                <div class="truckJourneyInfo-header-line-item font-bold">
                    <span [i18n]="'truck-journeys.list.truck-journey'"></span>
                    <span> #{{ truckJourney.rank + 1 }}</span>
                </div>
                <div class="truckJourneyInfo-header-line-item">
                    <span [i18n]="'truck-journeys.list.from'" class="font-bold"></span>
                    <span>: {{ truckJourney.fromLocation }} - </span>
                    <span [i18n]="'truck-journeys.list.to'" class="font-bold"></span>
                    <span>: {{ truckJourney.toLocation }}</span>
                </div>
                <div class="truckJourneyInfo-header-line-item">
                    <span [i18n]="'truck-journeys.list.stops'" class="font-bold"></span>
                    <span>: {{ truckJourney.totalStops }}</span>
                </div>
                <div class="truckJourneyInfo-header-line-item">
                    <span [i18n]="'truck-journeys.list.vehicle'" class="font-bold"></span>
                    <span>: {{ truckJourney.vehicle }}</span>
                </div>
            </div>
            <ng-container *ngIf="!truckJourneyOpened">
                <div *ngIf="truckJourney.loads.length > 0; else noLoads">
                    <div>
                        <span [i18n]="[{target: 'innerHTML', key: 'truck-journeys.detail.deliveries'}]" class="font-bold"></span>
                        <span>&nbsp;<ng-container *ngFor="let delivery of uniqueDeliveries; let last = last"
                            ><app-delivery-number [deliveryNumber]="delivery.number"
                                                  [salesOrderNumber]="delivery.salesOrderNumber"
                                                  displayType="text"></app-delivery-number><span *ngIf="!last"> ; </span></ng-container></span>
                    </div>
                    <div>
                        <span [i18n]="[{target: 'innerHTML', key: 'truck-journeys.detail.loads-ids'}]" class="font-bold"></span>
                        <span> {{ loadIds }}</span>
                    </div>
                </div>
                <ng-template #noLoads>
                    <div>
                        <span [i18n]="[{target: 'innerHTML', key: 'truck-journeys.detail.loads-ids'}]" class="font-bold"></span>
                        <span>&nbsp;</span>
                        <span [i18n]="'truck-journeys.detail.no-assigned-loads'"></span>
                    </div>
                </ng-template>
            </ng-container>
        </div>
        <div class="truckJourneyInfo-header-actions">
            <i *ngIf="!readOnly" (click)="editTruckjourney(false)" class="fa fa-pen"></i>
            <i (click)="openOrCloseTruckJourney()"
               class="fa" *ngIf="truckJourney.loads.length > 0"
               [ngClass]="{ 'fa-angle-down': !truckJourneyOpened, 'fa-angle-up': truckJourneyOpened }"></i>
        </div>
    </div>
    <div [ngClass]="{ 'isShow': truckJourneyOpened && truckJourney.loads.length > 0 }" class="truckJourneyInfo-content">
        <div class="truckJourneyInfo-content-head">
            <div class="truckJourneyInfo-content-head-label">
                <span [i18n]="[{target: 'innerHTML', key: 'truck-journeys.detail.loads-ids'}]" class="font-bold"></span>
                <span> {{ truckJourney.loads.length }}</span>
            </div>
            <i *ngIf="!readOnly" (click)="editTruckjourney(true)" class="fa fa-plus" ></i>
        </div>
        <ng-container *ngFor="let truckJourneyLoad of truckJourney.loads">
            <app-truck-journey-load [truckJourneyLoad]="truckJourneyLoad"
                                    [editableLoad]="false"
                                    [deletableLoad]="false">
            </app-truck-journey-load>
        </ng-container>
    </div>
</div>
